import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-with-label',
  templateUrl: './info-with-label.component.html',
  styleUrls: ['./info-with-label.component.scss'],
})
export class InfoWithLabelComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;

  constructor() { }

  ngOnInit() {}

}
